module.exports = __webpack_public_path__ + "static/media/dash.c97ba61e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/dash.svg
// module id = 317
// module chunks = 0